var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bet-info"},[_c('div',{staticClass:"bet-info__result"},[_vm._v(_vm._s(_vm.result))]),(_vm.round)?_c('div',{staticClass:"bet-info__round"},[_vm._v("Jornada "+_vm._s(_vm.round))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }